/*
1	ผู้ดูแลระบบ
2	ผู้บริหาร
3	ฝ่าย สกจก
4	ฝ่าย ปฏิบัติการ
5	ฝ่าย โรงงาน
6	ผู้เชี่ยมชม
7	ฝ่ายขาย
8	ผู้จัดการสนาม (Survey)
9	Project Coordinator (CO) - Survey
10 ผู้อนุมัติโครงการ
11 ผู้จัดการสนาม (Project)
12 Project Coordinator (CO) - Project
13 Site Supervisor
14 ศูนย์สนาม (PM Officer)
15 ผู้อำนวยการฝ่ายปฏิบัติการ
16 สำนักกรรมการผู้จัดการ (สกจก)
17 ผู้จัดการแผนก (Project)
18 DM Devision Manager (CO เดิม)
19 Survey PM
20 RTO (Receiving & Tagging Officer) Sitesup รับเสาโรงร่วม
21 Logistic
*/

const RolePermissionConfigs = {
  dashboard_overview: [1, 2, 10],
  dashboard_operation: [1, 3, 4, 7, 8, 10, 11, 12, 13, 14, 15, 18, 19, 20],
  project: [1, 2, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21],
  sale_order: [1, 2, 3, 5, 7, 14, 15, 16, 21],
  survey: [1, 2, 4, 7, 8, 9, 11, 10, 14, 15, 18, 19, 21],
  shipping_request: [1, 2, 4, 5, 7, 11, 13, 14, 15, 18, 19, 20, 21],
  shipping: [1, 2, 5, 7, 13, 14, 15, 20, 21],
  request: [1, 2, 3, 4, 5, 7, 10, 11, 13, 14, 15, 16, 18, 19, 20, 21],
  maintenance: [1, 2, 3, 4, 5, 7, 10, 11, 13, 14, 15, 16, 18, 19, 20, 21],
  print: [1, 5, 20, 21],
  user: [1],
  machine: [1, 3, 4, 7, 8, 9, 10, 12, 13, 14, 15],
  external_api_audit_log: [1],
  receive_scan_log: [1],
  survey_sales_attachment: [1, 7],
}

export default RolePermissionConfigs
